// @ts-nocheck
import getJsonLdScriptId from "@insite/client-framework/Common/Utilities/getJsonLdScriptId";
import parseQueryString from "@insite/client-framework/Common/Utilities/parseQueryString";
import prepareBreadcrumbStructuredPageData from "@insite/client-framework/Common/Utilities/prepareBreadcrumbStructuredPageData";
import setPageMetadata from "@insite/client-framework/Common/Utilities/setPageMetadata";
import { trackPageChange } from "@insite/client-framework/Common/Utilities/tracking";
import { CategoryContext } from "@insite/client-framework/Components/CategoryContext";
import { HasDeferredApiContext, withCallDeferredApi } from "@insite/client-framework/Components/DeferredApiContext";
import { HasShellContext } from "@insite/client-framework/Components/IsInShell";
import Zone from "@insite/client-framework/Components/Zone";
import { redirectTo, setStatusCode } from "@insite/client-framework/ServerSideRendering";
import { getContentByVersionPath } from "@insite/client-framework/Services/ContentService";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import setBreadcrumbs from "@insite/client-framework/Store/Components/Breadcrumbs/Handlers/SetBreadcrumbs";
import {
    getSearchDataModeActive,
    getSelectedCategoryPath,
    getSettingsCollection,
} from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCatalogPageStateByPath } from "@insite/client-framework/Store/Data/CatalogPages/CatalogPagesSelectors";
import { getCategoryState } from "@insite/client-framework/Store/Data/Categories/CategoriesSelectors";
import {
    getAlternateLanguageUrls,
    getCanonicalUrlByPath,
    getCurrentPage,
    getLocation,
} from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";
import clearAllProductFilters from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearAllProductFilters";
import clearProducts from "@insite/client-framework/Store/Pages/ProductList/Handlers/ClearProducts";
import displayProducts from "@insite/client-framework/Store/Pages/ProductList/Handlers/DisplayProducts";
import loadProductsPricingAndInventory from "@insite/client-framework/Store/Pages/ProductList/Handlers/LoadProductsPricingAndInventory";
import prepareProductRecs from "@insite/client-framework/Store/Pages/ProductList/Handlers/PrepareProductRecs";
import sendOdpEvents from "@insite/client-framework/Store/Pages/ProductList/Handlers/SendOdpEvents";
import translate from "@insite/client-framework/Translate";
import { HideFooter, HideHeader, OpenGraphImage, OpenGraphTitle } from "@insite/client-framework/Types/FieldDefinition";
import PageModule from "@insite/client-framework/Types/PageModule";
import PageProps from "@insite/client-framework/Types/PageProps";
import Modals from "@insite/content-library/Components/Modals";
import ProductCompareFlyOut from "@insite/content-library/Components/ProductCompareFlyOut";
import Page from "@insite/mobius/Page";
import { HasHistory, withHistory } from "@insite/mobius/utilities/HistoryContext";
import { getPrevCurrentNextQueryString } from "@insite/mobius/utilities/linkElementsManipulation";
import * as React from "react";
import { connect, ResolveThunks } from "react-redux";

/* Starter Custom Code - Start */
import constants from "@store/constants";
import { getContentSearchDataView } from "@store/Framework/Store/Data/ContentSearch/ContentSearchSelectors";
import loadContentSearchResults from "@store/Framework/Store/Starter/Data/ContentSearch/Handlers/LoadContentSearchResults";
import updateSearchFields from "@store/Framework/Store/Starter/Pages/ProductList/Handlers/UpdateSearchFields";
import { getContentSearchParameter } from "@store/Framework/Store/Starter/Pages/ProductList/ProductListSelectors";
import {
    getIsSearchPage,
    getSearchQuery,
} from "@toolkit/Framework/Store/Toolkit/Pages/ProductList/ProductListSelectors";
import qs from "qs";
/* Starter Custom Code - End */

/* Store Custom Code - Start */
import { getCategorySearchDataView } from "@store/Framework/Store/Data/CategorySearch/CategorySearchSelectors";
import loadCategorySearchResults from "@store/Framework/Store/Store/Data/CategorySearch/Handlers/LoadCategorySearchResults";
/* Store Custom Code - End */

const mapStateToProps = (state: ApplicationState) => {
    const location = getLocation(state);
    const pathnameLowerCase = location.pathname.toLowerCase();
    const path =
        getSelectedCategoryPath(state) ||
        (location.pathname === getContentByVersionPath
            ? parseQueryString<{ categoryPath: string }>(location.search).categoryPath
            : "") ||
        (pathnameLowerCase.startsWith("/content/") || pathnameLowerCase.startsWith("/.spire/")
            ? ""
            : location.pathname);
    const {
        pages: {
            productList: {
                isLoading,
                productFilters,
                parameter,
                isSearchPage,
                filterQuery,
                productInfosByProductId,
                isCanceled,
            },
        },
    } = state;
    const catalogPage = getCatalogPageStateByPath(state, path).value;
    const productsDataView = getProductsDataView(state, parameter);
    const page = getCurrentPage(state);
    /* Starter Custom Code - Start */
    const contentSearchDataView = getContentSearchDataView(state);
    const searchQuery = getSearchQuery(state);
    const contentSearchParameter = getContentSearchParameter(state); // Store Custom Code
    const { extensionContentSearchSettings, customSettings } = getSettingsCollection(state);
    const parsedQueryString: { query: ""; currentTab: ""; cpage: undefined; cpageSize: undefined } = parseQueryString(
        location.search,
    );
    const enableContentSearchResults =
        extensionContentSearchSettings && extensionContentSearchSettings.enableContentSearchResults;
    const enableCategorySearchResults = customSettings?.enableCategorySearchResults ?? true; // Store Custom Code
    const categorySearchDataView = getCategorySearchDataView(state); // Store Custom Code
    const hasNoContentSearchResults =
        !enableContentSearchResults ||
        (!contentSearchDataView.isLoading && contentSearchDataView.value && !contentSearchDataView.value?.length);
    /* Starter Custom Code - End */
    return {
        isLoading,
        stockedItemsOnly: productFilters.stockedItemsOnly,
        previouslyPurchasedProducts: productFilters.previouslyPurchasedProducts,
        query: productFilters.query,
        productsDataView,
        firstProductDetailPath: productsDataView.value
            ? productInfosByProductId[productsDataView.value[0]?.id]?.productDetailPath
            : undefined,
        filterQuery,
        isSearchPage: isSearchPage || getIsSearchPage(state), // Starter Custom Code
        search: location.search,
        path,
        breadcrumbLinks: state.components.breadcrumbs.links,
        productListCatalogPage: getCatalogPageStateByPath(state, path).value,
        websiteName: state.context.website.name,
        pages: state.pages,
        location: getLocation(state),
        category: getCategoryState(state, catalogPage?.categoryIdWithBrandId ?? catalogPage?.categoryId).value,
        websiteSettings: getSettingsCollection(state).websiteSettings,
        searchDataModeActive: getSearchDataModeActive(state),
        searchPath: getSettingsCollection(state).searchSettings.searchPath,
        alternateLanguageUrls: getAlternateLanguageUrls(state, page.id),
        page,
        deferredApis: state.context.deferredApiCalls,
        productInfosByProductId,
        parameter,
        unfilteredApiParameter: state.pages.productList.unfilteredApiParameter,
        canonicalUrl: getCanonicalUrlByPath(state, path),
        enableServerSideRendering: getSettingsCollection(state).websiteSettings.enableServerSideRendering,
        isCanceled,
        // Starter Custom Code
        contentSearchParameter,
        contentSearchDataView,
        enableContentSearchResults,
        enableCategorySearchResults, // Store Custom Code
        hasNoContentSearchResults,
        categorySearchDataView, // Store Custom Code
        parsedQueryString,
        searchQuery,
    };
};

const mapDispatchToProps = {
    clearAllProductFilters,
    displayProducts,
    setBreadcrumbs,
    clearProducts,
    loadProductsPricingAndInventory,
    sendOdpEvents,
    prepareProductRecs,
    // Starter Custom Code
    loadContentSearchResults,
    loadCategorySearchResults, // Store Custom Code
    updateSearchFields,
};

export const ProductListPageDataContext = React.createContext<{ ref?: React.RefObject<HTMLSpanElement | null> }>({
    ref: undefined,
});

type Props = HasHistory &
    ReturnType<typeof mapStateToProps> &
    ResolveThunks<typeof mapDispatchToProps> &
    HasShellContext &
    PageProps &
    HasDeferredApiContext;

class ProductListPage extends React.Component<Props, { sentEventFor?: string }> {
    constructor(props: Props) {
        super(props);
        this.state = {};
    }

    afterFilters = React.createRef<HTMLSpanElement | null>();
    isFirstLoad = true; // Starter Custom Code

    loadProducts() {
        const { displayProducts, path, search } = this.props;

        displayProducts({
            path,
            queryString: search,
            isSearch: this.isSearchPath(),
            relevancy: true,
        });
    }

    isSearchPath() {
        return !!this.props.path.toLowerCase().startsWith(`/${this.props.searchPath.toLowerCase()}`);
    }

    UNSAFE_componentWillMount(): void {
        if (!IS_SERVER_SIDE) {
            // cleanup state for future redirect captures
            window?.localStorage?.removeItem("searchTermRedirectUrl");
        }

        const { productsDataView, breadcrumbLinks } = this.props;
        if (
            ((!productsDataView.value && !productsDataView.isLoading) || this.props.isCanceled) &&
            !(IS_SERVER_SIDE && this.props.deferredApis.catalog > 0)
        ) {
            this.loadProducts();
        } else if (!IS_SERVER_SIDE && productsDataView.value) {
            if (this.checkSearchTermRedirectUrl()) {
                return;
            }
        } else if (this.props.isSearchPage) {
            this.redirectToProductDetailIfExactMatch();
        }

        this.props.callDeferredApis({
            pricingHandler: () => {
                this.props.loadProductsPricingAndInventory({
                    products: this.props.productsDataView.value,
                    productInfosByProductId: this.props.productInfosByProductId,
                });
            },
            inventoryHandler: () => {
                this.props.loadProductsPricingAndInventory({
                    products: this.props.productsDataView.value,
                    productInfosByProductId: this.props.productInfosByProductId,
                });
            },
        });

        if (this.props.productListCatalogPage) {
            this.setMetadata();
            if (
                breadcrumbLinks
                    ?.slice(1)
                    ?.map(o => o.children?.toString())
                    .join(",") !==
                    this.props.productListCatalogPage.breadCrumbs
                        ?.slice(1)
                        ?.map(o => o.text)
                        .join(",") ||
                (breadcrumbLinks?.length && breadcrumbLinks[0].children !== translate("Home_Breadcrumb"))
            ) {
                this.setProductListBreadcrumbs();
            }
        } else if (this.props.isSearchPage) {
            this.setSearchPageMetadata(translate("Search Results"));
            if (!this.props.breadcrumbLinks) {
                this.setSearchBreadcrumbs();
            }
        }

        this.sendOdpEventsIfNeeded();
    }

    componentDidMount(): void {
        if (this.props.enableServerSideRendering) {
            this.props.prepareProductRecs({
                isSearch: this.isSearchPath(),
                catalogPage: this.props.productListCatalogPage,
                products: this.props.productsDataView.value,
            });
        }
    }

    componentWillUnmount(): void {
        const { contentSearchDataView /* Starter Custom Code */, productsDataView } = this.props;
        if (!productsDataView.isLoading) {
            this.props.clearProducts();
            this.props.setBreadcrumbs({ links: undefined });
        }
        /* Starter Custom Code - Start */
        if (!contentSearchDataView.isLoading) {
            this.props.updateSearchFields({
                query: "",
                currentTab: constants.contentSearch.tabKey.products,
                cpage: undefined,
                cpageSize: undefined,
                type: "Replace",
            });
        }
        /* Starter Custom Code - End */
    }

    // Starter Custom Code - componentDidMount is not working because "isSearchPage" is false on mount and it's needed to excute search content code only in search page and not in PLP

    componentDidUpdate(prevProps: Props): void {
        const {
            isLoading,
            filterQuery,
            location: { pathname, search },
            productListCatalogPage,
            searchDataModeActive,
            // Starter Custom Code
            contentSearchDataView,
            contentSearchParameter,
            enableContentSearchResults,
            searchQuery,
        } = this.props;

        if (productListCatalogPage) {
            this.setMetadata();
            trackPageChange();
            if (
                productListCatalogPage.categoryId !== prevProps.productListCatalogPage?.categoryId ||
                !this.props.breadcrumbLinks
            ) {
                this.setProductListBreadcrumbs();
            }
        } else if (this.props.isSearchPage && search && search.length > 0) {
            // For pages that do not have a productListCatalogPage, mainly the Search Page
            this.setSearchPageMetadata(translate("Search Results"));
            trackPageChange();
            if (this.props.query !== prevProps.query || !this.props.breadcrumbLinks) {
                this.setSearchBreadcrumbs();
            }

            /* Starter Custom Code - Start */
            if (enableContentSearchResults) {
                if (this.isFirstLoad && searchQuery) {
                    this.isFirstLoad = false;
                    this.props.updateSearchFields({
                        query: searchQuery,
                        // Need to send them all individually to avoid adding params from the products tab
                        currentTab:
                            this.props.parsedQueryString.currentTab ||
                            contentSearchParameter.currentTab ||
                            constants.contentSearch.tabKey.products,
                        cpage: this.props.parsedQueryString.cpage,
                        cpageSize: this.props.parsedQueryString.cpageSize,
                        type: "Replace",
                    });
                }
                // Needed for content search paging and currentTab switching. Some param can be undefined.
                if (
                    !this.isFirstLoad &&
                    !isLoading &&
                    JSON.stringify(contentSearchParameter) !== JSON.stringify(prevProps.contentSearchParameter)
                ) {
                    const queryString = qs.stringify({
                        // Need it to keep all the filters from the products tab to go back to the same filters when switching tabs
                        ...this.props.parsedQueryString,
                        /*
                        Need it to avoid changing the query in the url when there is a "Search instead" or "Did you mean" result,
                        the query doesn't change in the url even if there is a corrected query before we click on the Did you mean link
                        */
                        query: this.props.parsedQueryString.query,
                        // Need to send them all individually in the right order to avoid the url changing
                        currentTab: contentSearchParameter.currentTab,
                        cpage: contentSearchParameter.cpage,
                        cpageSize: contentSearchParameter.cpageSize,
                    });
                    this.props.history.replace(
                        `${this.props.location.pathname}${queryString !== "" ? `?${queryString}` : ""}`,
                    );
                }

                if (
                    !this.isFirstLoad &&
                    !contentSearchDataView.isLoading &&
                    !contentSearchDataView.value &&
                    searchQuery
                ) {
                    const { currentTab, ...parameter } = contentSearchParameter;
                    this.props.loadContentSearchResults({
                        ...parameter,
                        query: searchQuery,
                    });
                    this.isFirstLoad = true;
                }
            }
            /* Starter Custom Code - End */
            /* Store Custom Code - Start */
            if (
                this.props.enableCategorySearchResults &&
                searchQuery &&
                !this.props.categorySearchDataView.isLoading &&
                !this.props.categorySearchDataView.value
            ) {
                this.props.loadCategorySearchResults({
                    query: searchQuery,
                });
            }
            /* Store Custom Code - End */
        }

        if (this.props.query !== prevProps.query) {
            window?.localStorage?.removeItem("searchTermRedirectUrl");
        }

        // handle the query string change requests initiated by the filtering widget setQueryFilter calls
        // Make sure we are fully loaded, since a loading product list will change the filteQuery to match the current pathname/search
        // This can trigger a loop with the pathname/search updating and the filterQuery not updated till the productList is loaded
        if (
            !isLoading &&
            filterQuery !== prevProps.filterQuery &&
            /* Starter Custom Code - Start */
            // Only required in a search page if the current tab is the product tab or in a PLP. Not necessary if it's the content tab, as it manages product filters.
            (!this.props.enableContentSearchResults ||
                !this.props.isSearchPage ||
                contentSearchParameter.currentTab === constants.contentSearch.tabKey.products)
            /* Starter Custom Code - End */
        ) {
            /* Starter Custom Code - Start */
            let currentUrl = `${pathname}${search}`;
            if (this.props.enableContentSearchResults && this.props.isSearchPage) {
                /*
                Need to remove currentTab parameter to avoid triggering history push when currentTab appears in url.
                It's the history.replace above that handles the currentTab in the url.
                */
                const searchWithoutCurrentTab = search?.replace(/&currentTab=[^&]*(&|$)/, "") || "";
                currentUrl = `${pathname}${searchWithoutCurrentTab}`;
            }
            /* Starter Custom Code - End */
            const newUrl = filterQuery ? `${pathname}?${filterQuery}` : pathname;

            /* Starter Custom Code - Start */
            let finalUrl = "";
            if (this.props.enableContentSearchResults && this.props.isSearchPage) {
                // "filterQuery" includes the search query (query=) and must be deleted
                const filterUrl = filterQuery?.replace(/query=[^&]*(&|$)/, "") || "";
                const contentSearchQueryString = qs.stringify({
                    query: this.props.parsedQueryString.query,
                    currentTab: this.props.parsedQueryString.currentTab,
                    cpage: this.props.parsedQueryString.cpage,
                    cpageSize: this.props.parsedQueryString.cpageSize,
                });
                finalUrl = `${pathname}?${contentSearchQueryString}${filterUrl ? `&${filterUrl}` : ""}`;
            } else {
                finalUrl = newUrl;
            }
            /* Starter Custom Code - End */

            if (newUrl !== currentUrl) {
                this.props.history.push(finalUrl); // Starter Custom Code
                return;
            }
        }

        if (!isLoading && this.props.productsDataView.value && pathname === prevProps.location.pathname) {
            if (this.checkSearchTermRedirectUrl()) {
                return;
            }

            this.redirectToProductDetailIfExactMatch();
        }

        /* Starter Custom Code - Start */
        // Need to find if there is a new query to launch "loadProducts()"
        const regexToRemoveContentSearchParams = /&(?:currentTab=[^&]*|cpage=[^&]*|cpagesize=[^&]*)/g;
        const searchQueryWithoutContentSearchParams = this.props.search.replace(regexToRemoveContentSearchParams, "");
        const prevSearchQueryWithoutContentSearchParams = prevProps.search.replace(
            regexToRemoveContentSearchParams,
            "",
        );
        const hasNewContentSearchParams =
            enableContentSearchResults &&
            this.props.isSearchPage &&
            searchQueryWithoutContentSearchParams !== prevSearchQueryWithoutContentSearchParams;
        /* Starter Custom Code - End */

        if (
            /* Starter Custom Code - Start */
            !isLoading &&
            (((!enableContentSearchResults || !this.props.isSearchPage) &&
                (search !== prevProps.search || this.props.path !== prevProps.path)) ||
                hasNewContentSearchParams) &&
            search?.indexOf("criteria=") === -1
            /* Starter Custom Code - End */
        ) {
            if (this.props.path !== prevProps.path) {
                this.props.clearAllProductFilters({
                    removeAll: true,
                });
            }
            /* Starter Custom Code - Start */
            // Needed to launch "loadContentSearchResults()"
            if (this.props.isSearchPage) {
                const query = this.props.search.match(/[?&]query=([^&]*)/);
                if (query) {
                    this.props.updateSearchFields({ query: query[1] });
                }
            }
            /* Starter Custom Code - End */
            this.loadProducts();
        }

        if (searchDataModeActive !== prevProps.searchDataModeActive) {
            // refresh the search results when search data mode has been toggled in the cms shell
            this.loadProducts();
        }

        this.sendOdpEventsIfNeeded();
    }

    sendOdpEventsIfNeeded = () => {
        if (IS_SERVER_SIDE) {
            return;
        }

        const { parameter, sendOdpEvents, productListCatalogPage, productsDataView, unfilteredApiParameter } =
            this.props;

        if (!unfilteredApiParameter) {
            return;
        }

        const nextParameter = JSON.stringify(parameter);
        if (nextParameter !== this.state.sentEventFor && productsDataView?.value) {
            this.setState({
                sentEventFor: nextParameter,
            });

            let lastParameter = this.state.sentEventFor ? JSON.parse(this.state.sentEventFor) : undefined;
            sendOdpEvents({
                catalogPage: productListCatalogPage,
                lastParameter,
            });
        }
    };

    checkSearchTermRedirectUrl() {
        if (!window || !this.props.productsDataView.value) {
            return false;
        }

        let searchTermRedirectUrl = this.props.productsDataView.searchTermRedirectUrl;
        if (!searchTermRedirectUrl) {
            return false;
        }

        const startsWithProtocol = searchTermRedirectUrl.lastIndexOf("http", 0) === 0;
        if (!startsWithProtocol && searchTermRedirectUrl[0] !== "/") {
            searchTermRedirectUrl = `/${searchTermRedirectUrl}`;
        }

        const locationPath = startsWithProtocol
            ? window.location.toString()
            : `${window.location.pathname}${window.location.search}`;

        if (locationPath === searchTermRedirectUrl) {
            window.localStorage.setItem("searchTermRedirectUrl", searchTermRedirectUrl);
            return false;
        }

        if (window.localStorage.getItem("searchTermRedirectUrl") === searchTermRedirectUrl) {
            return false;
        }

        if (startsWithProtocol) {
            window.location.replace(searchTermRedirectUrl);
        } else {
            this.props.history.replace(searchTermRedirectUrl);
        }

        window.localStorage.setItem("searchTermRedirectUrl", searchTermRedirectUrl);

        return true;
    }

    redirectToProductDetailIfExactMatch() {
        if (!this.props.productsDataView.value) {
            return;
        }

        const {
            location: { search },
            firstProductDetailPath,
            // Starter Custom Code
            hasNoContentSearchResults,
        } = this.props;

        const { exactMatch, value: products } = this.props.productsDataView;
        if (exactMatch && products.length && hasNoContentSearchResults /* Starter Custom Code */) {
            let productDetailUrl = firstProductDetailPath ?? products[0].canonicalUrl;
            const parsedQuery = parseQueryString<{ criteria: string; query: string }>(search);
            const query = parsedQuery.criteria || parsedQuery.query;
            if (!query) {
                return;
            }
            if (productDetailUrl.indexOf("?") !== -1) {
                productDetailUrl += `&criteria=${encodeURIComponent(query)}`;
            } else {
                productDetailUrl += `?criteria=${encodeURIComponent(query)}`;
            }

            if (IS_SERVER_SIDE) {
                setStatusCode(302);
                redirectTo(productDetailUrl);
            } else {
                this.props.history.replace(productDetailUrl);
            }
        }
    }

    getQueryStrings() {
        if (this.props.productsDataView.value && this.props.productsDataView.pagination) {
            const { prevPageUri, nextPageUri, currentPage } = this.props.productsDataView.pagination;
            const { prevQueryString, currentQueryString, nextQueryString } = getPrevCurrentNextQueryString(
                prevPageUri,
                nextPageUri,
                currentPage,
                this.props.filterQuery ?? "",
            );
            return { prevQueryString, currentQueryString, nextQueryString };
        }

        const { prevQueryString, currentQueryString, nextQueryString } = getPrevCurrentNextQueryString("", "", 1, "");
        return { prevQueryString, currentQueryString, nextQueryString };
    }

    setMetadata() {
        const { productListCatalogPage, websiteName, location, websiteSettings } = this.props;
        if (!productListCatalogPage) {
            return;
        }

        const {
            metaDescription,
            metaKeywords,
            openGraphImage,
            openGraphTitle,
            openGraphUrl,
            title,
            primaryImagePath,
            canonicalPath,
            alternateLanguageUrls,
        } = productListCatalogPage;

        const { prevQueryString, currentQueryString, nextQueryString } = this.getQueryStrings();

        setPageMetadata(
            {
                metaDescription,
                metaKeywords,
                openGraphImage: openGraphImage || primaryImagePath,
                openGraphTitle,
                openGraphUrl,
                title,
                currentPath: location.pathname,
                canonicalPath,
                alternateLanguageUrls: alternateLanguageUrls ?? undefined,
                websiteName,
                currentQueryString,
                prevQueryString,
                nextQueryString,
                structuredPageData: websiteSettings.enableBreadcrumbStructuredData
                    ? prepareBreadcrumbStructuredPageData(this.props.breadcrumbLinks)
                    : undefined,
                jsonLdScriptId: getJsonLdScriptId(this.props.page.type),
            },
            websiteSettings,
        );
    }

    setSearchPageMetadata(title: string) {
        const {
            websiteName,
            location,
            websiteSettings,
            fields,
            productsDataView,
            alternateLanguageUrls,
            canonicalUrl,
        } = this.props;
        const firstProduct = productsDataView.value && productsDataView.value[0];
        const { prevQueryString, currentQueryString, nextQueryString } = this.getQueryStrings();

        setPageMetadata(
            {
                title,
                currentPath: location.pathname,
                websiteName,
                openGraphImage:
                    fields.openGraphImage ||
                    firstProduct?.largeImagePath ||
                    firstProduct?.mediumImagePath ||
                    firstProduct?.smallImagePath,
                openGraphTitle: fields.openGraphTitle,
                openGraphUrl: location.pathname + location.search,
                alternateLanguageUrls,
                currentQueryString,
                prevQueryString,
                nextQueryString,
                structuredPageData: websiteSettings.enableBreadcrumbStructuredData
                    ? prepareBreadcrumbStructuredPageData(this.props.breadcrumbLinks)
                    : undefined,
                jsonLdScriptId: getJsonLdScriptId(this.props.page.type),
                canonicalPath: canonicalUrl,
            },
            websiteSettings,
        );
    }

    setProductListBreadcrumbs() {
        this.props.setBreadcrumbs({
            links: this.props.productListCatalogPage!.breadCrumbs!.map(o => ({ children: o.text, href: o.url })),
        });
    }

    setSearchBreadcrumbs() {
        this.props.setBreadcrumbs({
            links: [
                { children: translate("Home_Breadcrumb"), href: "/" },
                {
                    children: `${translate("Search Results")}${
                        this.props.query ? `${translate("{0}:", "")} ${this.props.query}` : "" // Starter Custom Code
                    }`,
                },
            ],
        });
    }

    render() {
        const windowIfDefined = typeof window === "undefined" ? null : window;
        if (
            this.props.productsDataView.value?.length &&
            ((this.props.productsDataView.exactMatch &&
                this.props.hasNoContentSearchResults) /* Starter Custom Code */ ||
                (this.props.productsDataView.searchTermRedirectUrl &&
                    !windowIfDefined?.localStorage?.getItem("searchTermRedirectUrl")))
        ) {
            // prevent a flash of data when PLP immediately redirects to PDP
            return null;
        }

        return (
            <Page>
                <CategoryContext.Provider value={this.props.category}>
                    <ProductListPageDataContext.Provider value={{ ref: this.afterFilters }}>
                        <Zone contentId={this.props.id} zoneName="Content" />
                        <Modals />
                        <ProductCompareFlyOut />
                    </ProductListPageDataContext.Provider>
                </CategoryContext.Provider>
            </Page>
        );
    }
}

const pageModule: PageModule = {
    component: connect(mapStateToProps, mapDispatchToProps)(withCallDeferredApi(withHistory(ProductListPage))),
    definition: {
        hasEditableUrlSegment: false,
        hasEditableTitle: false,
        supportsCategorySelection: true,
        pageType: "System",
        fieldDefinitions: [HideHeader, HideFooter, OpenGraphTitle, OpenGraphImage],
    },
};

export default pageModule;

/**
 * @deprecated Use string literal "ProductListPage" instead of this constant.
 */
export const ProductListPageContext = "ProductListPage";
